import { Component } from '@angular/core';
import { AlertService } from 'src/app/services/alert/alert.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { User } from 'src/app/services/user/model/user';

@Component({
  selector: 'app-header-name',
  templateUrl: './header-name.component.html',
  styleUrl: './header-name.component.scss',
})
export class HeaderNameComponent {
  user: User;

  constructor(
    private authService: AuthService,
    private alertService: AlertService
  ) {
    this.authService.userData$.subscribe(async (res: any) => {
      this.user = new User();
      if (res) {
        this.user.fromJson(res);
      }
    });
  }

  async onClickLogout() {
    await this.alertService.showAlertYesNo(
      'Confirmação!',
      'Deseja realmente sair do Colapp?',
      async () => {
        this.authService.logout(false);
      },
      () => {}
    );
  }
}
